import { render, staticRenderFns } from "./AgregarLaboratorio.vue?vue&type=template&id=5ae42bd8"
import script from "./AgregarLaboratorio.vue?vue&type=script&lang=js"
export * from "./AgregarLaboratorio.vue?vue&type=script&lang=js"
import style0 from "./AgregarLaboratorio.vue?vue&type=style&index=0&id=5ae42bd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports